const getHeaders = () => {
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        // Add any other headers you need here
    }
}

export default getHeaders;